import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { useConfigurationContext } from '../../../core/application/contexts'
import { WasteType } from '../../../core/domain/models'
import WasteTypeGrid from '../../modal/wasteTypeFilterModal/WasteTypeGrid'
import NavigationButtons from '../NavigationButtons'

export interface ISubmitDropoffWastesProps {
  onDismiss: () => void
  onValidate: (types: WasteType[]) => void
  currentlySelectedTypes: WasteType[]
}

const SubmitDropoffWastes: React.FC<ISubmitDropoffWastesProps> = ({
  onDismiss,
  onValidate,
  currentlySelectedTypes
}) => {
  const intl = useIntl()
  const { wasteTypeList } = useConfigurationContext()
  const [selectedTypes, setSelectedTypes] = useState<Array<string>>(currentlySelectedTypes.map((value) => value.id))

  const onValidateClick = () => {
    const selectedWasteTypes = wasteTypeList.filter((value) => {
      return selectedTypes.includes(value.id)
    })
    onValidate(selectedWasteTypes)
  }

  return (
    <SubmitDropoffWastesContainer>
      <WastesContainer>
        <WasteTypeGrid
          selectedWasteTypes={selectedTypes}
          onSelect={(id) => {
            const index = selectedTypes.indexOf(id)
            if (index >= 0) {
              // Remove type
              const updated = [...selectedTypes]
              updated.splice(index, 1)
              setSelectedTypes(updated)
            } else {
              // Add type
              setSelectedTypes([...selectedTypes, id])
            }
          }}
          wasteTypes={wasteTypeList}
        />
      </WastesContainer>
      <NavigationButtons
        previousTitle={intl.formatMessage({ id: 'SubmitDropoff.navigation.cancel' })}
        nextTitle={intl.formatMessage({ id: 'SubmitDropoff.navigation.validate' })}
        onPreviousClick={onDismiss}
        onNextClick={onValidateClick}
      />
    </SubmitDropoffWastesContainer>
  )
}

const WastesContainer = styled.div`
  overflow-y: auto;
  max-height: 300px;
`

const SubmitDropoffWastesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export default SubmitDropoffWastes
